import React, { Component } from 'react';
import { Provider, Consumer, MyContext } from '../../../../context/Context'
// import axios from '../../../../services/AxiosOrders'
// import { Redirect } from 'react-router-dom'


// import { Dropdown, Label, Divider, Form, Header, Message } from 'semantic-ui-react'
// import { Grid, Container } from 'semantic-ui-react'
// import HeaderBreadcrubms from '../../layout/Header_Bread'
// import UploadImage from '../../filepod/UploadImage'
import MasterForm from './MasterForm'
import {Provider as FilesProvider, FilesConsumer} from '../../filepod/FileShare'

export class AddCard extends Component {

    constructor(props) {
      super(props);

    }
  // state = {
  //   imgUrl: '',
  //   heading: '',
  //   text: '',
  //   errors: {},
  //   text: '', 
  //   title:'',
  //   description:'',
  //   toDashboard: false
  // };

  // onChange = e => this.setState({ [e.target.name]: e.target.value });

  // onSubmit = async (dispatch, auth, e) => {
  //   e.preventDefault();

  //   const { imgUrl, heading, text, title, description , service } = this.state;

  //   if (title === '') {
  //     this.setState({ errors: { title: 'title is required' } });
  //     return;
  //   }

  //   if (description === '') {
  //     this.setState({ errors: { description: 'description is required' } });
  //     return;
  //   }

  //   if (service === '') {
  //     this.setState({ errors: { service: 'service is required' } });
  //     return;
  //   }

  //   const newCard = {
  //     heading,
  //     imgUrl,
  //     text,
  //     userId: auth.localId
  //   };



  //   // /cards/${id}.json?auth=${auth.token}
  //   // const resp = await axios.post(`/cards.json?auth=${auth.token}`, newCard);
  //   const resp = await axios.post(`/${auth.localId}/cards.json?auth=${auth.token}`, newCard);
  //   dispatch({ type: 'ADD_CARD', payload: { ...newCard, id: resp.data.name } });
  //   this.setState({ errors: {}, toDashboard: true });
  // };



  render() {
    // const { imgUrl, heading, text, errors } = this.state;
    // if (this.state.toDashboard) {
    //   return <Redirect to="/cardlist" />;
    // }
    return (
      // <Provider>
      <Consumer>
        {value => {
          const {   auth, myFiles } = value;

          console.log(auth)
          return (
   
              // <Consumer>

              //   {
              //     value => {

              //       const {  logs, kcount, dispatch_files } = value
              //       console.log('---- dispatch_files AddCard.js------')
              //       console.log((myFiles))
              //       return (
                      <React.Fragment>
                    
                          <MasterForm auth = {auth} myFiles = {myFiles}></MasterForm>



                   
                      </React.Fragment>
              //       );
              //     }
              //   }

              // </Consumer>

          );
        }}
      </Consumer>
      // </Provider>
    );
  }
}


AddCard.contextType = MyContext;
export default AddCard;